/* 
Menu links color change, when they are active
*/
document.addEventListener("DOMContentLoaded", function() {
    // Get all menu links
    const menuLinks = document.querySelectorAll('.header__menu-item');

    // Loop through each link
    menuLinks.forEach(link => {
      // Check if href matches current URL path
      if (link.getAttribute('href') === window.location.pathname) {
        link.style.color = '#141920'; // Change link color
        const span = link.querySelector('span');
        if (span) span.style.color = '#141920'; // Change inner span color
      }
    });
  });

